import * as React from "react";
import Image from "../../../../Image/index";
import createAnimatedComponent from "../createAnimatedComponent";
var AnimatedImage_default = createAnimatedComponent(Image);
export {
  AnimatedImage_default as default
};
//# sourceMappingURL=AnimatedImage.js.map
